<div class="login-page">
  <div class="content">
    <!-- <h1 class="app-name">Sb Admin Material</h1> -->
    <form class="login-form" fxFlex fxLayout="column" (ngSubmit)="login()" [formGroup]="loginForm" novalidate>
      <div class="text-center">
        <h2 class="app-name">
          <!-- <img width="250" height="80" src="assets/images/jeddah-logo-2x.png" /> -->
          <img width="250" height="80" src="assets/images/makkah-logo-2x.png" />
        </h2>
      </div>
      <div fxFlex fxlayout="row" fxlayout.lt-md="column">
        <div fxFlexFill>
          <mat-form-field class="w-100" appearance="outline">
            <mat-label>{{ 'auth.login.username.title' | translate }}</mat-label>
            <input matInput formControlName="username" type="text" />
          </mat-form-field>
        </div>
      </div>
      <div fxFlex fxLayout="row" fxLayout.lt-md="column">
        <div fxFlexFill>
          <mat-form-field class="w-100" appearance="outline">
            <mat-label> {{ 'auth.login.password.title' | translate }} </mat-label>
            <input matInput formControlName="password" [type]="hide ? 'password' : 'text'" />
            <button
              mat-icon-button
              matSuffix
              (click)="hide = !hide"
              [attr.aria-label]="'Hide password'"
              [attr.aria-pressed]="hide"
              type="button"
            >
              <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
          </mat-form-field>
          <ng-container *ngIf="error">
            <div class="font-danger mat-error ng-star-inserted">
              {{ error }}
            </div>
          </ng-container>
        </div>
      </div>

      <div fxFlex fxLayout="row" fxLayout.lt-md="column">
        <div fxFlexFill class="text-left">
          <div fxFlex="100%" class="secondary-font forgot-password ">
            <a class="underline-none  gold-color" [routerLink]="['/reset-password']">{{
              'auth.login.password.forgot' | translate
            }}</a>
          </div>
        </div>
      </div>

      <div fxFlex fxLayout="row" fxLayout.lt-md="column">
        <div fxFlexFill>
          <button
            mat-flat-button
            color="primary"
            class="w-100"
            type="submit"
            [disabled]="loginForm.invalid || isLoading"
          >
            <app-loader class="inline-loader" [isLoading]="isLoading"></app-loader>

            {{ 'auth.login.submit' | translate }}
          </button>
        </div>
      </div>
      <div class="login-footer">
        <div fxFlex fxLayout="row" fxLayout.lt-md="column">
          <div fxFlex class="login-checkbox">
            <mat-checkbox formControlName="remember" color="primary">
              {{ 'auth.login.remember' | translate }}</mat-checkbox
            >
          </div>
        </div>
        <!-- Language Menu -->
        <div>
          <button mat-button type="button" [matMenuTriggerFor]="languageMenu" class="no-padding font-color ml-6">
            <img
              *ngIf="selectedLanguage"
              [src]="selectedLanguage.flag"
              style="width:20px; height:14px; object-fit:cover; border-radius:2px; margin-right:6px;"
            />
            {{ selectedLanguage?.label }}
            <mat-icon class="font-color">arrow_drop_down</mat-icon>
          </button>

          <mat-menu #languageMenu="matMenu" class="header-menu" xPosition="before">
            <button
              mat-menu-item
              type="button"
              class="m-w-200 border-bottom font-color"
              *ngFor="let lang of languages"
              (click)="setLanguage(lang)"
            >
              <img
                [src]="lang.flag"
                style="width:20px; height:14px; object-fit:cover; border-radius:2px; margin-right:8px;"
              />
              <span>{{ lang.label }}</span>
            </button>
          </mat-menu>
        </div>
      </div>
    </form>

    <div class="saudi-side-logo"></div>
  </div>
</div>
